var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadStereo = function SvgFadStereo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 192c35.899 0 65-28.654 65-64 0-35.346-29.101-64-65-64s-65 28.654-65 64c0 35.346 29.101 64 65 64z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 192c35.899 0 65-28.654 65-64 0-35.346-29.101-64-65-64s-65 28.654-65 64c0 35.346 29.101 64 65 64z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.802 175.407c14.711 0 27.954-5.94 37.193-15.423-12.232-16.88-14.177-19.888-14.177-32.38 0-12.244 6.151-18.7 14.663-31.871-9.256-9.778-22.708-15.93-37.679-15.93-27.92 0-50.555 21.401-50.555 47.802 0 26.4 22.634 47.802 50.555 47.802z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.802 175.407c27.922 0 50.556-21.401 50.556-47.802 0-26.4-22.634-47.803-50.556-47.803-14.787 0-28.092 6.004-37.337 15.574 6.922 14.053 14.172 20.206 14.172 32.624 0 12.802-6.03 20.525-13.402 32.614 9.206 9.115 22.185 14.793 36.567 14.793z",
    fill: "#FFF"
  }))));
};
export { SvgFadStereo as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-stereo.2386fc6d.svg";